// URLs to project routes
export const routes = {
  home: "/",
  about: "/about",
  team: "/team",
  projects: "/projects",
  contact: "/contact",
  career: "/careers",
  community: "/community",
  store: "/store",
  admin: "/admin/",
  // Added specific game routes
  gameComeUp: "/games/the-come-up",
  gameAescension: "/games/aescension",
  gameMimicry: "/games/mimicry",
};

// URLs to all contact information
export const contactRoutes = {
    email: 'mailto:info@icarusdevteam.com',
    linkedIn: 'https://www.linkedin.com/company/icarus-development/',
    twitter: 'https://www.x.com/ICARUSALPHAINC',
    instagram: 'https://www.instagram.com/',
    facebook: 'https://www.facebook.com/',
    apply: 'https://form.jotform.com/240935764094161'
};